import styled from 'styled-components'

export const Wrapper = styled.div`
  > div + div {
    margin: 0 !important;
    padding: 0 !important;
    margin-top: 40px !important;
    padding-top: 40px !important;
    border-top: 1px solid #d9d9d9;
  }
`
